<template>
  <div class="btns input-text-size">
    <div class="payment-btns">
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="input-text-size" text color="blue darken-1"
           v-bind="attrs" v-on="on" @click="openDialog">
           <v-icon>
             {{icons.mdiPlus}}
           </v-icon>
          </v-btn>
        </template>
        <span>Create New Payment</span>
      </v-tooltip>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="input-text-size" text color="blue darken-1" v-bind="attrs" v-on="on"
            @click="printReceiptOutsideDialogBox">
            <v-icon>
              {{ icons.mdiPrinter }}
            </v-icon>
          </v-btn>
        </template>
        <span>Print Paid Receipt</span>
      </v-tooltip>
    </div>
    <!-- <v-btn class="input-text-size" text color="blue darken-1" @click="voidAllFunc">
      Void All
    </v-btn> -->
    <!-- Segmented rather than switches: each of these names one of two modes, and a switch only
         ever showed the one it was in - so "Half Mode" over an off knob was unreadable, and the
         same two modes rendered as a switch here and as a toggle in the payment dialog on the
         same screen. The handlers and the store writes are the ones the switches used. -->
    <div class="payment-mode-toggles">
      <BinaryToggle
        id="paymentButtonsPrintOrEmailToggle"
        off-label="Print"
        on-label="Email"
        v-model="togglePrintOrEmail" />
      <BinaryToggle
        id="paymentButtonsHalfToggle"
        off-label="Full"
        on-label="Half"
        :value="halfOrPostmark.half"
        @input="isOn => onChangeHalfOrPostmark(isOn, 'half')" />
      <BinaryToggle
        id="paymentButtonsPostmarkToggle"
        off-label="Normal"
        on-label="Postmark OK"
        :value="halfOrPostmark.postmark"
        @input="isOn => onChangeHalfOrPostmark(isOn, 'postmark')" />
    </div>
    <v-textarea class="input-text-size dec-line-height mt-2" rows="5" outlined
     rounded hide-details :value="headerInfo" />
    <div
      v-if="activeTransItem && (activeTransItem.createdBy || activeTransItem.createdWhen)"
      class="mt-2 input-text-size payment-created-info"
    >
      <div class="payment-created-info-label">User Name</div>
      <div class="payment-created-info-value">{{ activeTransItem.createdBy || '—' }}</div>
      <div class="payment-created-info-label mt-1">Date/Time</div>
      <div class="payment-created-info-value">
        {{ activeTransItem.createdWhen ? toLocalDateTime(activeTransItem.createdWhen) : '—' }}
      </div>
    </div>
  <div>
    <CRUDDialog
      :baseCrudKey='emailStatements'
      :canSave="true"
      canSaveCustomLabel="Send"
      :onlyDialogHeaderName="emailStatementHeader"
      dialogDynamicWidth='550'
      @upsertItem="handleEmailStatements"
    ><template v-slot:[`editedItem`]="{}">
        <EmailStatementDialoge :baseCrudKey="emailStatements" />
      </template>
    </CRUDDialog>
  </div>
  </div>
</template>

<script>
import {
  mapMutations, mapActions, mapGetters, mapState,
} from 'vuex';
import {
  mdiPrinter,
  mdiCupOutline,
  mdiPlus,
} from '@mdi/js';
import { clients } from '../../../util/clients';
import { generateQueryString } from '../../common/base/report/report-util';
import '../../../assets/style.css';
import BinaryToggle from '../../common/base/BinaryToggle.vue';
import CRUDDialog from '../../common/base/crud-2.0/CRUDDialog.vue';
import EmailStatementDialoge from './EmailStatementDialoge.vue';
import { getRawJwt } from '../../../util/jwt';
import { printerHandler } from '../../../util/pdf-to-printer.util';
import { getWorkstationNumber } from '../../../util/workstation-util';
import { toLocalDateTime } from '../../../util/shared/vue-global';
// import { commonVoidFunc } from '../common-utils/CommonTaxPaymentFunctionalities';

const { backendRest } = clients.direct;

export default {
  props: {

    handleLoadTaxPayments: {
      type: Function,
      default: () => ({}),
    },
    activeTransItem: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      baseCrudKey: 'paymentTransactionList',
      icons: {
        mdiPrinter,
        mdiCupOutline,
        mdiPlus,
      },
      togglePrintOrEmail: false,
      emailStatements: 'emailStatementsCrudKey',
      emailStatementHeader: 'Email Send',
      wkstNumber: getWorkstationNumber(),
    };
  },
  components: {
    BinaryToggle,
    CRUDDialog,
    EmailStatementDialoge,
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'criteria',
    ]),
    ...mapGetters(['todaysDate']),
    ...mapState({
      latestFiscalYear: (state) => state.tax.taxCommon.latestFiscalYear,
      halfOrPostmark: (state) => state.tax.taxPayment.halfOrPostmark,
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem || {},
    }),
    editEmailItemStatements: {
      get() {
        return this.item(this.emailStatements);
      },
      set(value) {
        this.setItem([this.emailStatements, value]);
      },
    },
    rowItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    headerInfo() {
      const textArea = [];
      const paidBy = this.rowItem.paymentDetails && this.rowItem.paymentDetails.length > 0 ? this.rowItem.paymentDetails[0].paidBy : '';
      if (paidBy && paidBy.length > 0) {
        textArea.push(`Paid by: ${paidBy}`);
      }
      return textArea;
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    toLocalDateTime,
    ...mapActions(['reAuth', 'custumColrFlashMsg']),
    ...mapMutations('base/crud', [
      'setIsVisible',
      'setItem',
      'setCriteria',
    ]),
    ...mapMutations('tax/taxPayment', [
      'setHalfOrPostmark',
    ]),
    ...mapActions('tax/taxPayment', [
      'upsertPaymentById',
    ]),
    ...mapActions('SystemConfig', [
      'getGlobalSettingStore',
    ]),
    ...mapActions('tax/taxPayment', [
      'sendPrintReceiptToEMail',
    ]),
    // voidAllFunc() {
    //   const selItem = this.rowItem;
    //   if (selItem._id) {
    //     const retVoidFormat = commonVoidFunc(selItem);
    //     if (retVoidFormat.taxDetails || retVoidFormat.paymentDetails) {
    //       this.$emit('callBackForUpsert', retVoidFormat, false);
    //     }
    //   } else this.custumColrFlashMsg({ msg: 'Please select a record' });
    // },
    openDialog() {
      this.$emit('handlePrePaymentDialog');
    },
    getAuthToken() {
      return getRawJwt();
    },
    async printReceiptOutsideDialogBox() {
      if (this.rowItem._id) {
        if (!this.togglePrintOrEmail) {
          const paymentId = this.rowItem._id;
          const { jwt } = await this.reAuth();
          const params = [
            `paymentId=${paymentId}`,
            `token=${jwt}`,
          ];
          if (this.devSetting && this.devSetting.isTestEnvironment) {
            params.push('isTestCafe=1');
          }
          const queryString = generateQueryString(params);
          const url = `${backendRest.defaults.baseURL}/taxpayment/print-paid-receipt${queryString}`;
          // window.open(url, '_blank');
          printerHandler(this, { url, reportName: 'paidReceipts', deafultPrinterMode: true });
          const item = this.item(this.baseCrudKey);
          const updatedItem = { _id: item._id };
          await this.upsertPaymentById({
            item: updatedItem,
          }).then(() => {
            this.handleLoadTaxPayments();
          });
        } else {
          this.handleEmailStatement();
        }
      } else this.custumColrFlashMsg({ msg: 'Please select a record' });
    },
    onChangeHalfOrPostmark(val, whichOne) {
      let isItNull = false;
      if (val) isItNull = val;
      if (whichOne === 'half') {
        this.setHalfOrPostmark({ res: isItNull, whichOne });
        this.setHalfOrPostmark({ res: isItNull, whichOne: 'dialogHalf' });
      } else {
        this.setHalfOrPostmark({ res: isItNull, whichOne });
        this.setHalfOrPostmark({ res: isItNull, whichOne: 'dialogPostmark' });
      }
    },
    onChangeReportPrintOption(val, whichOne) {
      let isItNull = false;
      if (val) isItNull = val;
      if (whichOne === 'half') {
        this.setHalfOrPostmark({ res: isItNull, whichOne });
        this.setHalfOrPostmark({ res: isItNull, whichOne: 'dialogHalf' });
      } else {
        this.setHalfOrPostmark({ res: isItNull, whichOne });
        this.setHalfOrPostmark({ res: isItNull, whichOne: 'dialogPostmark' });
      }
    },
    handleEmailStatement() {
      const itemData = this.item(this.baseCrudKey);
      const paymentId = this.rowItem._id;
      this.editEmailItemStatements.paymentId = paymentId;
      this.editEmailItemStatements.emailAdd = itemData.emailAddess;
      this.editEmailItemStatements.bccEmailAddress = this.paymentSettingItem.bccEmailAddress;
      this.editEmailItemStatements.subjectLine = this.paymentSettingItem.subjectLine;
      this.editEmailItemStatements.subjectBody = this.paymentSettingItem.subjectBody;
      this.setIsVisible([this.emailStatements, true]);
    },
    async handleEmailStatements() {
      const {
        bccEmailAddress, emailAdd, subjectBody, subjectLine, paymentId,
      } = this.editEmailItemStatements;

      // Always ensure penaltyDate is present and correct
      let penaltyDate = '';
      if (this.rowItem && this.rowItem.penaltyDate) {
        penaltyDate = this.rowItem.penaltyDate;
      } else if (this.editEmailItemStatements && this.editEmailItemStatements.penaltyDate) {
        penaltyDate = this.editEmailItemStatements.penaltyDate;
      } else {
        penaltyDate = '';
      }

      const item = {
        email: emailAdd,
        bccEmailAddress,
        subject: subjectLine,
        subjectBody,
        paymentId,
        penaltyDate,
        token: this.getAuthToken(),
        wkst: this.wkstNumber,
      };
      this.sendPrintReceiptToEMail({ item });
      // alert('handle email', item);
    },
  },
};
</script>
<style scoped>
.payment-btns {
  display: flex;
  gap: 1rem;
  margin: 0;
  padding: 0;
  flex-direction: row;
}

.v-input--selection-controls.v-input {
  margin-top: 0;
}

/* The three mode toggles stack, and each is as wide as its own longest label. Stretching them
   to a common width keeps the side panel from looking ragged. */
.payment-mode-toggles {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  margin: 8px 0;
}

.btns {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
}
.payment-created-info {
  width: 100%;
  text-align: left;
  padding: 0 4px;
}
.payment-created-info-label {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.2;
}
.payment-created-info-value {
  line-height: 1.2;
  margin-bottom: 2px;
}
</style>
